var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3984 6.50078C20.3984 6.18252 20.272 5.8773 20.047 5.65225C19.8219 5.42721 19.5167 5.30078 19.1984 5.30078H4.79844C4.48018 5.30078 4.17495 5.42721 3.94991 5.65225C3.72486 5.8773 3.59844 6.18252 3.59844 6.50078C3.59844 6.81904 3.72486 7.12427 3.94991 7.34931C4.17495 7.57435 4.48018 7.70078 4.79844 7.70078H19.1984C19.5167 7.70078 19.8219 7.57435 20.047 7.34931C20.272 7.12427 20.3984 6.81904 20.3984 6.50078ZM20.3984 12.5008C20.3984 12.1825 20.272 11.8773 20.047 11.6523C19.8219 11.4272 19.5167 11.3008 19.1984 11.3008H4.79844C4.48018 11.3008 4.17495 11.4272 3.94991 11.6523C3.72486 11.8773 3.59844 12.1825 3.59844 12.5008C3.59844 12.819 3.72486 13.1243 3.94991 13.3493C4.17495 13.5744 4.48018 13.7008 4.79844 13.7008H19.1984C19.5167 13.7008 19.8219 13.5744 20.047 13.3493C20.272 13.1243 20.3984 12.819 20.3984 12.5008ZM13.1984 18.5008C13.1984 18.1825 13.072 17.8773 12.847 17.6523C12.6219 17.4272 12.3167 17.3008 11.9984 17.3008H4.79844C4.48018 17.3008 4.17495 17.4272 3.94991 17.6523C3.72486 17.8773 3.59844 18.1825 3.59844 18.5008C3.59844 18.819 3.72486 19.1243 3.94991 19.3493C4.17495 19.5744 4.48018 19.7008 4.79844 19.7008H11.9984C12.3167 19.7008 12.6219 19.5744 12.847 19.3493C13.072 19.1243 13.1984 18.819 13.1984 18.5008Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.7d78b78e9205a141e85d52b49dc53b13.svg";
export { ForwardRef as ReactComponent };